import React from 'react';
import moment from 'moment/moment';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';

interface LastUpdateProps {
    updatedBy: string;
    updatedDate: string;
    id: string;
}
export const LastUpdateContent: React.FC<LastUpdateProps> = ({ updatedBy, updatedDate, id}) => {

    const formattedUpdatedDate = () => {
        return moment.utc(updatedDate).local().format('MM/DD/YYYY');
    };

    const formattedUpdatedBy = () => {
        if( !updatedBy.includes('@') || updatedBy === 'System') {
            return <>
                {formattedUpdatedDate()}
                <p className={'last-updated-cell'}>
                    <CustomIcon type={IconType.APPLY_ATT} size={12}/> AT&T</p>
            </>;
        } else {
            return <>
                <p>{updatedBy}</p>
                {formattedUpdatedDate()}
            </>;
        }
    };

    return <div className={'update-by-date'}>
        {formattedUpdatedBy()}
    </div>;
};